import { render, staticRenderFns } from "./import_clients.vue?vue&type=template&id=ce678f3a&scoped=true&"
import script from "./import_clients.vue?vue&type=script&lang=js&"
export * from "./import_clients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce678f3a",
  null
  
)

export default component.exports